import { CurrencyAddressCell } from '@root/entities/currency/ui/cells/currency-address-cell'

import type { WalletAssetModel } from '@root/entities/wallet'

type Props = {
  asset: WalletAssetModel
}

export const WalletAssetsTableAddressCell: React.FC<Props> = ({ asset }) => {
  return <CurrencyAddressCell currency={asset.currency} />
}
